import { Config } from "@/shared/config";

const userServiceUri = Config.UserServicebaseUri;
export default {
    getNotificationPreferences () {
        return `${userServiceUri}/user/v1/notificationPreferences/notification-preferences`;
  },
};